<template>
  <div>
    <div class="button-segmented relative">
      <button class="btn btn-primary" @click="toAwardCreate">
        <v-icon :style="{ fontSize: '20px' }" color="white" class="mr-2"
          >add</v-icon
        >
        <span>新增獎項</span>
      </button>
      <button
        class="btn btn-primary pa-0"
        @click="isAddNewButtonShow = !isAddNewButtonShow"
      >
        <v-icon :style="{ fontSize: '20px' }" color="white"
          >arrow_drop_down</v-icon
        >
      </button>
      <div
        v-if="isAddNewButtonShow"
        class="button-segmented-menu  absolute"
        style="top: 40px; z-index: 1;"
      >
        <div class="elevation-6 white">
          <div class="option" @click="toAwardCreate">新增單筆資料</div>
          <div class="option" @click="isUplodFilesDialogOpen = true">
            批次匯入CSV
          </div>
        </div>
      </div>
    </div>
    <!-- Dialog -->
    <AwardListDialog
      :isUplodFilesDialogOpen.sync="isUplodFilesDialogOpen"
      :url="importUrl"
      exampleFile="/awardsImportExample.xlsx"
      @handleReload="getAwards"
    ></AwardListDialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import AwardListDialog from '@/components/DialogDropZone/index.vue';

export default {
  components: {
    AwardListDialog,
  },
  data: () => ({
    isAddNewButtonShow: false,
    isUplodFilesDialogOpen: false,
    importUrl: '/import/award',
  }),
  methods: {
    ...mapActions('award', { getAwards: 'find' }),
    toAwardCreate() {
      this.$router.push({ path: '/awards/create' });
    },
  },
};
</script>

<style></style>
